import { Injectable } from '@angular/core';

/** Scoped state registry for dynamic bulk-edit section forms. */
@Injectable()
export class BulkEditSectionFormService {
  private readonly registry = new Map<string, () => unknown>();

  register(sectionId: string, getStateFn: () => unknown): void {
    this.registry.set(sectionId, getStateFn);
  }

  unregister(sectionId: string): void {
    this.registry.delete(sectionId);
  }

  getState(sectionId: string): unknown {
    return this.registry.get(sectionId)?.();
  }
}
